import request from '@/utils/request';
import { BASE_API, BASE_WENJUAN, WENJUAN_URL } from '@/utils/consts'

//添加排班
export function addScheduling(data) {
  return request(`${BASE_API}/clinic_scheduling/save`,{
    method:'POST',
    data
  });
}

//排班列表
export function getScheduling(data) {
  return request(`${BASE_API}/clinic_scheduling/list`,{
    method:'POST',
    data
  });
}

//删除排班
export function deleteScheduling(data) {
  return request(`${BASE_API}/clinic_scheduling/delete/${data.id}`,{
    method:'DELETE',
  });
}

//编辑排班
export function updateScheduling(data) {
  return request(`${BASE_API}/clinic_scheduling/update`,{
    method:'POST',
    data
  });
}